import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import { TextareaInput } from '../../organisms';
export function MessageInput({ onChange, value }) {
    // Handlers
    const handleChange = useCallback((text) => {
        onChange(text || null);
    }, [onChange]);
    // Render
    return (_jsx(TextareaInput, { label: "Add a message for your relationship manager (optional)", value: value !== null && value !== void 0 ? value : '', onValueChange: handleChange, placeholder: "Enter message here" }));
}
